import { createSlice } from "@reduxjs/toolkit";

const deliveryOrderSlice = createSlice({
    name: "deliveryOrder",
    initialState: {
        orders: [],
        page: 1,
        pages: 1,
        count: 1,
        total: 0,
        shipping: 0,
    },
    reducers: {
        setOrders(state, action) {
            const data = action.payload;
            state.orders = data.results;
            state.pages = data.pages;
        },
        setOrderStats(state, action) {
            const data = action.payload;
            state.count = data.count;
            state.shipping = data.totalShipping;
            state.total = data.total;
        },
        updateOrderInList(state, action) {
            const { id, data } = action.payload;
            const idx = state.orders.findIndex((o) => o.id === id);
            if (idx !== -1) {
                state.orders[idx] = { ...state.orders[idx], ...data };
            }
        },
        setPage(state, action) {
            const page = action.payload;
            state.page = page;
        },
    },
});

export const { setOrders, setOrderStats, setPage, updateOrderInList } = deliveryOrderSlice.actions;

export default deliveryOrderSlice;
